import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    presentPrompt: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }) => ({ ...state, presentPrompt: true }),
    }),
    cancelEditPrompt: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }) => ({
        ...state,
        presentPrompt: false,
        prompt: undefined,
        generating: undefined,
      }),
    }),
    editPrompt: store.actions.standalone({
      data: store.actions.Data.asIs<{ prompt: string }>(),
      reducer: ({ state, data: { prompt } }) => ({ ...state, prompt }),
    }),
    setFile: store.actions.standalone({
      data: store.actions.Data.asIs<{
        file: File
      }>(),
      reducer: ({ state, data: { file } }) => ({
        ...state,
        file,
      }),
    }),
    saveEditPrompt: store.actions.standalone({
      data: store.actions.Data.NONE,
    }),
    submitPrompt: store.actions.request({
      input: store.actions.Data.asIs<{ prompt: string }>(),
      output: store.actions.Data.NONE,
      reducers: {
        request: ({ state }) => ({
          ...state,
          generating: { loading: true },
        }),
        success: ({ state }) => ({
          ...state,
          prompt: undefined,
          presentPrompt: false,
          generating: undefined,
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          generating: { error },
        }),
        cancellation: ({ state, data: { reason } }) => ({
          ...state,
          generating: { error: reason },
        }),
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
